import { useMutation } from "react-query";
import http from "infra/http";

function useDeleteContato() {
  return useMutation(
    `/v1/contato/:id`,
    (id: string) => http.delete(`/v1/contato/${id}`),
    { retry: false }
  );
}

export default useDeleteContato;
